module.exports = __webpack_public_path__ + "Simple-Line-Icons.78f07e2c2a535c26ef21.woff";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/Simple-Line-Icons.woff?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.woff?v=2.4.0
// module chunks = styles